<template>
  <div>
    <div class="row pt-1" :class="{ 'ml-0': isChild }">
      <div class="col-sm">
        <div class="row">
          <div class="col">
            <span class="data-name font-weight-normal">Año Fiscal:</span>
            <p class="data font-weight-normal">
              {{ model.fiscalYearDescription }}
            </p>
          </div>
        </div>
        <div v-if="(model.amendments || []).length > 0 && !isChild" class="row">
          <div class="col">
            <span class="color-primary-2 font-weight-normal">
              ({{ model.amendments.length }}) Enmienda(s)
            </span>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <span class="data-name font-weight-normal">Número de Contrato:</span>
        <p class="data font-weight-normal">
          {{ model.contractNumber ? model.contractNumber : '-' }}
        </p>
      </div>
      <div class="col-sm">
        <span class="data-name font-weight-normal">
          Fecha Comienzo/Finalización:
        </span>
        <p class="data font-weight-normal">
          {{ getStartEndDate(model) }}
        </p>
      </div>
      <div v-if="model.isDirectPayment" class="col-sm-2 mt-2">
        <span
          class="badge badge-pill badge p-2 px-2"
          :class="`border-color--green`"
          style="background-color: #e3ffe9"
        >
          <em :class="`fas fa-dollar-sign color-green`" />
          <span class="font-weight-bold ml-1" :class="`color-green`">
            Pago Directo
          </span>
        </span>
      </div>
      <div v-else class="col-sm-2">
        <span class="data-name font-weight-normal">Monto:</span>
        <p class="data font-weight-normal">
          {{ model.balanceMaxAmt | price }}
        </p>
      </div>
      <div class="col-sm-1">
        <span v-if="!isChild" class="data-name font-weight-normal">Total:</span>
        <p v-if="!isChild" class="data font-weight-normal">
          {{ model.totalBalance | price }}
        </p>
      </div>
      <div class="col-sm text-center">
        <drop-down
          :class="{ 'ml-3': isChild }"
          :data-item="model"
          :items="getAvailableActions(model)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowContractProvider',
  props: {
    isChild: {
      type: Boolean,
      default: () => false,
    },
    model: {
      type: Object,
      default: () => ({}),
    },
    contractInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getStartEndDate() {
      return (model) => {
        return `${this.$formatDate(
          new Date(
            model.effectiveFromDate ?? this.contractInfo.effectiveFromDate
          )
        )} - ${this.$formatDate(
          new Date(model.effectiveToDate ?? this.contractInfo.effectiveToDate)
        )}`;
      };
    },
    canAmendPreviousYear() {
      return this.userHasPermissions('provider.contract.canamendpreviousyear');
    },
    canAmend() {
      return this.userHasPermissions('provider.contract.canamend');
    },
  },
  methods: {
    showEnmendar(item) {
      let currentAcademicYear = this.$store.state.$_common.currentAcademicYear;

      return (
        this.canAmend &&
        !item.isDirectPayment &&
        !this.isChild &&
        item.isSignedFlag &&
        (currentAcademicYear?.id === this.model.fiscalYearId ||
          this.canAmendPreviousYear)
      );
    },
    getAvailableActions(item) {
      //Problem mapping getter

      let actions = [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-primary-1',
          click: this.onEdit,
        },
        {
          label: 'Enmendar',
          icon: 'fas fa-folder color-primary-1',
          visible: this.showEnmendar(item),
          click: this.onAmendment,
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-primary-3',
          click: this.onRemove,
          visible: !item.isSignedFlag,
        },
      ];

      return actions;
    },
    onEdit(item) {
      if (this.isChild) {
        this.onAmendment();
        return;
      }

      this.$router.push({
        name: 'contractAddEdit',
        params: { contractId: item.id },
      });
    },
    onAmendment() {
      this.$router.push({
        name: 'provider-amendment',
        params: {
          companyId: this.model.companyId,
          fiscalYearId: this.model.fiscalYearId,
          contractId: this.model.id,
        },
      });
    },
    onRemove() {
      this.$emit('remove', this.model);
    },
    toogleAmendments() {
      this.model.isOpened = !this.model.isOpened;
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped></style>
